module.exports = __webpack_public_path__ + "static/media/attendantIco.c54ccce7.svg";